export default {
      id: "funnel-usage",
      viewBox: "0 0 112 129",
      url: __webpack_public_path__ + "icons-sprite.f57ad8e.svg#funnel-usage",
      toString: function () {
        return this.url;
      }
    }